import { z } from 'zod';
import { AnalyticsSchema } from './analytics';
import { InitialDataSchema } from './initialData';
var GameDateSchema = z.string();
var PusherSchema = z.unknown();
var WindowSchema = z.record(z.unknown());
export var getCurrentUser = function () {
    var parsedWindow = WindowSchema.parse(window);
    var initialData = parsedWindow.initial_data;
    if (!initialData) {
        return undefined;
    }
    var currentUser = InitialDataSchema.parse(initialData).current_user;
    return currentUser;
};
export var getGameDate = function () {
    var gameDate = WindowSchema.parse(window).game_date;
    if (!gameDate) {
        return undefined;
    }
    return GameDateSchema.parse(gameDate);
};
export var getPusherFromWindow = function () {
    var pusher = WindowSchema.parse(window).Pusher;
    if (!pusher) {
        return undefined;
    }
    return PusherSchema.parse(pusher);
};
export var getAnalyticsFromWindow = function () {
    var analytics = WindowSchema.parse(window).analytics;
    if (!analytics) {
        return undefined;
    }
    /**
     * Sometimes analaytics is an array which is very weird.  When it is not the right object,
     * we will return undefined.
     */
    var analyticsParseResults = AnalyticsSchema.safeParse(analytics);
    if (analyticsParseResults.error) {
        return undefined;
    }
    return analyticsParseResults.data;
};
export var callInitData = function (data) {
    var initData = WindowSchema.parse(window).initData;
    if (!initData || typeof initData !== 'function') {
        return;
    }
    initData.call(window, data);
};
export var setActivateApp = function (activateFn) {
    window.activateApp = activateFn;
};
